<template>
	<div id="div" style="display: flex;">
		<svg v-if="show" id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%">
			<defs />
			<g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="24375bed" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="0" height="0" preserveAspectRatio="none"
							transform="translate(6484.303222630103, 3972.6623696968554)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/Rectangle 3399.558a635d.svg" />
					</g>
					<g>
						<text fill="rgb(0,0,0)" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="7.32px" font-style="normal" font-weight="normal" text-decoration="normal"
							x="6484.303222630103" y="3973.211369696856" text-anchor="start" dominant-baseline="central"
							fill-opacity="1"></text>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="c1bc403" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(6320.6124635622855,3996.4630278677137) rotate(90,0,0) translate(-6320.6124635622855,-3996.4630278677137)">
						<g>
							<image width="92.29970444384375" height="67.44978401665504" preserveAspectRatio="none"
								transform="translate(6274.462611340364, 3962.738135859386)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/水泵.10cebf2f.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="28641ca" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="141.9585685034568" height="111.09801013314011" preserveAspectRatio="none"
							transform="translate(6137.247482670636, 4217.525527752743)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/Group 6266527.5f7901ff.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="a8c276" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="91.44146970885745" height="69.0891104466923" preserveAspectRatio="none"
							transform="translate(6665.426150187982, 4209.841078595089)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/SHIFEIBENG.0fc02abf.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="c999817" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="93.08191415050908" height="162.47025015361584" preserveAspectRatio="none"
							transform="translate(6346.24602255182, 4073.6263071346543)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/SHIFEITONG.1faac2f9.svg" />
					</g>
					<g>
						<text fill="rgb(0,0,0)" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="7.32px" font-style="normal" font-weight="normal" text-decoration="normal"
							x="6392.786979627074" y="4155.410432211462" text-anchor="start" dominant-baseline="central"
							fill-opacity="1"></text>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="7f38a86d" name="mindNode" text="总阀">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="#FFFFFF" paint-order="fill stroke markers"
						d=" M 6308.130187471819 3832.298176579616 L 6352.3415734910195 3832.298176579616 L 6352.3415734910195 3832.298176579616 A 12.052993934168677 12.052993934168677 0 0 1 6364.394567425188 3844.351170513785 L 6364.394567425188 3844.351170513785 L 6364.394567425188 3844.351170513785 A 12.052993934168677 12.052993934168677 0 0 1 6352.3415734910195 3856.4041644479535 L 6308.130187471819 3856.4041644479535 L 6308.130187471819 3856.4041644479535 A 12.052993934168677 12.052993934168677 0 0 1 6296.077193537651 3844.351170513785 L 6296.077193537651 3844.351170513785 L 6296.077193537651 3844.351170513785 A 12.052993934168677 12.052993934168677 0 0 1 6308.130187471819 3832.298176579616"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-width="0.61"
						stroke-dasharray="" />
					<g>
						<text fill="#FFFFFF" stroke="none" font-family="微软雅黑 " font-size="12.2px" font-style="normal"
							font-weight="normal" text-decoration="normal" x="6318.035883533177" y="3845.2051705137847"
							text-anchor="start" dominant-baseline="central" fill-opacity="1">总阀
						</text>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="51f88f3c" name="mindNode" text="水泵">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="#FFFFFF" paint-order="fill stroke markers"
						d=" M 6243.464744752322 3960.927414181398 L 6287.676130771522 3960.927414181398 L 6287.676130771522 3960.927414181398 A 12.052993934168677 12.052993934168677 0 0 1 6299.729124705691 3972.9804081155667 L 6299.729124705691 3972.9804081155667 L 6299.729124705691 3972.9804081155667 A 12.052993934168677 12.052993934168677 0 0 1 6287.676130771522 3985.0334020497353 L 6243.464744752322 3985.0334020497353 L 6243.464744752322 3985.0334020497353 A 12.052993934168677 12.052993934168677 0 0 1 6231.411750818153 3972.9804081155667 L 6231.411750818153 3972.9804081155667 L 6231.411750818153 3972.9804081155667 A 12.052993934168677 12.052993934168677 0 0 1 6243.464744752322 3960.927414181398"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-width="0.61"
						stroke-dasharray="" />
					<g>
						<text fill="#FFFFFF" stroke="none" font-family="微软雅黑 " font-size="12.2px" font-style="normal"
							font-weight="normal" text-decoration="normal" x="6253.37044081368" y="3973.8344081155665"
							text-anchor="start" dominant-baseline="central" fill-opacity="1">水泵
						</text>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="50c316fd" name="mindNode"
					text="开启过滤系统">
					<path fill="none" stroke="none" />
					<g>
						<path fill="rgb(18,130,255,0)" stroke="none" paint-order="stroke fill markers"
							d=" M 6122.914287837221 3986.9117160408914 L 6204.62089934885 3986.9117160408914 L 6204.62089934885 3986.9117160408914 A 12.433614795247761 12.433614795247761 0 0 1 6217.054514144098 3999.345330836139 L 6217.054514144098 3999.345330836139 L 6217.054514144098 3999.345330836139 A 12.433614795247761 12.433614795247761 0 0 1 6204.62089934885 4011.7789456313867 L 6122.914287837221 4011.7789456313867 L 6122.914287837221 4011.7789456313867 A 12.433614795247761 12.433614795247761 0 0 1 6110.480673041973 3999.345330836139 L 6110.480673041973 3999.345330836139 L 6110.480673041973 3999.345330836139 A 12.433614795247761 12.433614795247761 0 0 1 6122.914287837221 3986.9117160408914"
							fill-opacity="1" />
					</g>
					<path fill="none" stroke="rgb(255,255,255)" paint-order="fill stroke markers"
						d=" M 6122.914287837221 3986.9117160408914 L 6204.62089934885 3986.9117160408914 L 6204.62089934885 3986.9117160408914 A 12.433614795247761 12.433614795247761 0 0 1 6217.054514144098 3999.345330836139 L 6217.054514144098 3999.345330836139 L 6217.054514144098 3999.345330836139 A 12.433614795247761 12.433614795247761 0 0 1 6204.62089934885 4011.7789456313867 L 6122.914287837221 4011.7789456313867 L 6122.914287837221 4011.7789456313867 A 12.433614795247761 12.433614795247761 0 0 1 6110.480673041973 3999.345330836139 L 6110.480673041973 3999.345330836139 L 6110.480673041973 3999.345330836139 A 12.433614795247761 12.433614795247761 0 0 1 6122.914287837221 3986.9117160408914"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-width="0.61"
						stroke-dasharray="" />
					<g>
						<text fill="rgb(255,255,255)" stroke="none" font-family="微软雅黑 " font-size="12.2px"
							font-style="normal" font-weight="normal" text-decoration="normal" x="6127.167602748309"
							y="4000.199330836139" text-anchor="start" dominant-baseline="central"
							fill-opacity="1">开启过滤系统
						</text>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="8a51853" name="mindNode"
					text="搅拌机4">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="#FFFFFF" paint-order="fill stroke markers"
						d=" M 6417.338620950807 4073.6263071346543 L 6461.550006970007 4073.6263071346543 L 6461.550006970007 4073.6263071346543 A 12.052993934168677 12.052993934168677 0 0 1 6473.603000904176 4085.679301068823 L 6473.603000904176 4085.6793010688234 L 6473.603000904176 4085.6793010688234 A 12.052993934168677 12.052993934168677 0 0 1 6461.550006970007 4097.732295002992 L 6417.338620950807 4097.732295002992 L 6417.338620950807 4097.732295002992 A 12.052993934168677 12.052993934168677 0 0 1 6405.2856270166385 4085.6793010688234 L 6405.2856270166385 4085.679301068823 L 6405.2856270166385 4085.679301068823 A 12.052993934168677 12.052993934168677 0 0 1 6417.338620950807 4073.6263071346543"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-width="0.61"
						stroke-dasharray="" />
					<g>
						<text fill="#FFFFFF" stroke="none" font-family="微软雅黑 " font-size="12.2px" font-style="normal"
							font-weight="normal" text-decoration="normal" x="6417.567124324177" y="4086.5333010688228"
							text-anchor="start" dominant-baseline="central" fill-opacity="1">搅拌机4
						</text>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="6e7dd3d4" name="mindNode"
					text="吸肥阀4">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="#FFFFFF" paint-order="fill stroke markers"
						d=" M 6474.269765857104 4129.644464835788 L 6518.4811518763045 4129.644464835788 L 6518.4811518763045 4129.644464835788 A 12.052993934168677 12.052993934168677 0 0 1 6530.534145810473 4141.697458769957 L 6530.534145810473 4141.697458769957 L 6530.534145810473 4141.697458769957 A 12.052993934168677 12.052993934168677 0 0 1 6518.4811518763045 4153.750452704126 L 6474.269765857104 4153.750452704126 L 6474.269765857104 4153.750452704126 A 12.052993934168677 12.052993934168677 0 0 1 6462.216771922936 4141.697458769957 L 6462.216771922936 4141.697458769957 L 6462.216771922936 4141.697458769957 A 12.052993934168677 12.052993934168677 0 0 1 6474.269765857104 4129.644464835788"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-width="0.61"
						stroke-dasharray="" />
					<g>
						<text fill="#FFFFFF" stroke="none" font-family="微软雅黑 " font-size="12.2px" font-style="normal"
							font-weight="normal" text-decoration="normal" x="6474.498269230474" y="4142.551458769957"
							text-anchor="start" dominant-baseline="central" fill-opacity="1">吸肥阀4
						</text>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="37953f1e" name="mindNode"
					text="施肥泵">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="#FFFFFF" paint-order="fill stroke markers"
						d=" M 6730.486574683629 4195.74293210513 L 6774.69796070283 4195.74293210513 L 6774.69796070283 4195.74293210513 A 12.052993934168677 12.052993934168677 0 0 1 6786.750954636998 4207.795926039299 L 6786.750954636998 4207.795926039299 L 6786.750954636998 4207.795926039299 A 12.052993934168677 12.052993934168677 0 0 1 6774.69796070283 4219.848919973468 L 6730.486574683629 4219.848919973468 L 6730.486574683629 4219.848919973468 A 12.052993934168677 12.052993934168677 0 0 1 6718.433580749461 4207.795926039299 L 6718.433580749461 4207.795926039299 L 6718.433580749461 4207.795926039299 A 12.052993934168677 12.052993934168677 0 0 1 6730.486574683629 4195.74293210513"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-width="0.61"
						stroke-dasharray="" />
					<g>
						<text fill="#FFFFFF" stroke="none" font-family="微软雅黑 " font-size="12.2px" font-style="normal"
							font-weight="normal" text-decoration="normal" x="6734.292272270866" y="4208.649926039299"
							text-anchor="start" dominant-baseline="central" fill-opacity="1">施肥泵
						</text>
					</g>
				</g>

				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="25c4481" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(6101.399917936265,4315.575066534844) rotate(90,0,0) translate(-6101.399917936265,-4315.575066534844)">
						<g>
							<image width="29.603844750589957" height="29.603844750589957" preserveAspectRatio="none"
								transform="translate(6086.59799556097, 4300.77314415955)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="f3f1c0d" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(6564.727598333005,4191.9445442751685) rotate(270,0,0) translate(-6564.727598333005,-4191.9445442751685)">
						<g>
							<image width="27.645896662204983" height="27.645896662204983" preserveAspectRatio="none"
								transform="translate(6550.904650001902, 4178.121595944066)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="7833b8a" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(6795.1962525956,4177.134600020167) rotate(270,0,0) translate(-6795.1962525956,-4177.134600020167)">
						<g>
							<image width="28.670492233777157" height="28.670492233777157" preserveAspectRatio="none"
								transform="translate(6780.861006478711, 4162.799353903279)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="5039a70f" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(6709.896282310428,4177.134600020173) rotate(180,0,0) translate(-6709.896282310428,-4177.134600020173)">
						<g>
							<image width="29.603844750590905" height="29.603844750590905" preserveAspectRatio="none"
								transform="translate(6695.094359935133, 4162.332677644878)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>

				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="867a57" name="line"
					line-name="line">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="undefined" paint-order="fill stroke markers"
							d=" M 6431.935803127705 4187.517604571957 L 6457.79304466603 4187.387805020753"
							stroke-linecap="square" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="36.6"
							stroke-dasharray="" />
					</g>
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="rgb(250,250,250)" paint-order="fill stroke markers"
						d=" M 6431.935803127705 4187.517604571957 L 6457.79304466603 4187.387805020753"
						stroke-opacity="1" stroke-linecap="square" stroke-linejoin="round" stroke-miterlimit="10"
						stroke-width="18.3" stroke-dasharray="" />
					<g>
						<path fill="none" stroke="rgb(84,199,255)" paint-order="fill stroke markers"
							d=" M 6431.935803127705 4187.517604571957 L 6457.79304466603 4187.387805020753"
							stroke-opacity="1" stroke-linecap="square" stroke-linejoin="round" stroke-miterlimit="10"
							stroke-width="6.1" stroke-dasharray="18.3,36.6" />
					</g>
					<g>
						<text fill="rgb(250,250,250)" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="7.32px" font-style="normal" font-weight="normal" text-decoration="normal"
							x="6444.864423896868" y="4188.001704796355" text-anchor="start" dominant-baseline="central"
							fill-opacity="1"></text>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="3ad0008b" name="line"
					line-name="line">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="undefined" paint-order="fill stroke markers"
							d=" M 6505.601572263412 4187.302037718676 L 6545.816005304104 4187.517604571948"
							stroke-linecap="square" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="36.6"
							stroke-dasharray="" />
					</g>
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="rgb(250,250,250)" paint-order="fill stroke markers"
						d=" M 6505.601572263412 4187.302037718676 L 6545.816005304104 4187.517604571948"
						stroke-opacity="1" stroke-linecap="square" stroke-linejoin="round" stroke-miterlimit="10"
						stroke-width="18.3" stroke-dasharray="" />
					<g>
						<path fill="none" stroke="rgb(84,199,255)" paint-order="fill stroke markers"
							d=" M 6505.601572263412 4187.302037718676 L 6545.816005304104 4187.517604571948"
							stroke-opacity="1" stroke-linecap="square" stroke-linejoin="round" stroke-miterlimit="10"
							stroke-width="6.1" stroke-dasharray="18.3,36.6" />
					</g>
					<g>
						<text fill="rgb(250,250,250)" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="7.32px" font-style="normal" font-weight="normal" text-decoration="normal"
							x="6525.708788783758" y="4187.958821145312" text-anchor="start" dominant-baseline="central"
							fill-opacity="1"></text>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="19cd0745" name="line"
					line-name="line">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="undefined" paint-order="fill stroke markers"
							d=" M 6800.550496189185 4291.976573147944 L 6800.33536732641 4195.487278462746"
							stroke-linecap="square" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="36.6"
							stroke-dasharray="" />
					</g>
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="rgb(250,250,250)" paint-order="fill stroke markers"
						d=" M 6800.550496189185 4291.976573147944 L 6800.33536732641 4195.487278462746"
						stroke-opacity="1" stroke-linecap="square" stroke-linejoin="round" stroke-miterlimit="10"
						stroke-width="18.3" stroke-dasharray="" />
					<g>
						<path fill="none" stroke="rgb(84,199,255)" paint-order="fill stroke markers"
							d=" M 6800.550496189185 4291.976573147944 L 6800.33536732641 4195.487278462746"
							stroke-opacity="1" stroke-linecap="square" stroke-linejoin="round" stroke-miterlimit="10"
							stroke-width="6.1" stroke-dasharray="18.3,36.6" />
					</g>
					<g>
						<text fill="rgb(250,250,250)" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="7.32px" font-style="normal" font-weight="normal" text-decoration="normal"
							x="6800.442931757798" y="4244.280925805345" text-anchor="start" dominant-baseline="central"
							fill-opacity="1"></text>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="548236bf" name="line"
					line-name="line">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="undefined" paint-order="fill stroke markers"
							d=" M 6704.849168060045 4218.965712157472 L 6704.63403919727 4194.622527312089"
							stroke-linecap="square" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="36.6"
							stroke-dasharray="" />
					</g>
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="rgb(250,250,250)" paint-order="fill stroke markers"
						d=" M 6704.849168060045 4218.965712157472 L 6704.63403919727 4194.622527312089"
						stroke-opacity="1" stroke-linecap="square" stroke-linejoin="round" stroke-miterlimit="10"
						stroke-width="18.3" stroke-dasharray="" />
					<g>
						<path fill="none" stroke="rgb(84,199,255)" paint-order="fill stroke markers"
							d=" M 6704.849168060045 4218.965712157472 L 6704.63403919727 4194.622527312089"
							stroke-opacity="1" stroke-linecap="square" stroke-linejoin="round" stroke-miterlimit="10"
							stroke-width="6.1" stroke-dasharray="18.3,36.6" />
					</g>
					<g>
						<text fill="rgb(250,250,250)" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="7.32px" font-style="normal" font-weight="normal" text-decoration="normal"
							x="6704.741603628658" y="4207.34311973478" text-anchor="start" dominant-baseline="central"
							fill-opacity="1"></text>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="3cc790fd" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(6489.169902978853,4178.713672839073) rotate(90,0,0) translate(-6489.169902978853,-4178.713672839073)">
						<g>
							<image width="38.78532703555449" height="44.603126090887656" preserveAspectRatio="none"
								transform="translate(6469.7772394610765, 4156.4121097936295)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/XIFEIDIANCIFA.e5e802e8.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="1f6ccab4" name="line"
					line-name="curve" from-id="a32e098" to-id="a32e098">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="e818b3" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="18.354383745366242" height="83.51244604141641" preserveAspectRatio="none"
							transform="translate(6398.376555786837, 3924.0454843934986)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/2.2be3631d.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="1cc8a3df" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="33.73437387454565" height="17.754933618181923" preserveAspectRatio="none"
							transform="translate(6353.333637372764, 4018.915860218243)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/3.44436492.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="489ade8" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="607.4186382342097" height="17.970965628231056" preserveAspectRatio="none"
							transform="translate(6279.206051174087, 4291.508101529881)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/7.e316eb6e.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="103363e" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="18.354383745366242" height="23.860698868976115" preserveAspectRatio="none"
							transform="translate(6333.478537981066, 4269.737987570887)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/8.f43db8bd.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="ccf2612" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="306.50790176466387" height="18.083062051012618" preserveAspectRatio="none"
							transform="translate(6359.741179994699, 4239.368050597824)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/9.dc2e9392.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="308c7e9b" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="31.843760696357364" height="16.7598740507144" preserveAspectRatio="none"
							transform="translate(6435.024579237057, 4178.922100693322)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 10.51eb1b65.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="474cbf6a" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="41.51047788423131" height="18.048033862709264" preserveAspectRatio="none"
							transform="translate(6509.569750872968, 4178.563362203403)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 11.141cbcbb.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="0142ccf" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="17.19376894485756" height="36.966603231443756" preserveAspectRatio="none"
							transform="translate(6561.86795980126, 4205.175415711259)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 12.f3d45a67.svg" />
					</g>
					<g>
						<text fill="rgb(0,0,0)" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="7.32px" font-style="normal" font-weight="normal" text-decoration="normal"
							x="6570.464844273689" y="4224.207717326981" text-anchor="start" dominant-baseline="central"
							fill-opacity="1"></text>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="2626491e" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="18.12340245529587" height="22.65425306911984" preserveAspectRatio="none"
							transform="translate(6695.39635513185, 4191.168169937261)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 13.20a4d574.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="d9def48" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="56.696766159728334" height="18.289279406363978" preserveAspectRatio="none"
							transform="translate(6724.2438846133555, 4162.876997827792)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 14.ccb19eab.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="2f5c5ed" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="17.88732983578121" height="101.9577800639529" preserveAspectRatio="none"
							transform="translate(6791.832203380908, 4191.469846137062)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 15.8bc95939.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="897122f" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="18.021597991659533" height="451.44102969107126" preserveAspectRatio="none"
							transform="translate(6868.462826563774, 3842.3565441432843)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 16.f5c3c5d9.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="7b59e9b" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="220.15520605509838" height="17.971853555518237" preserveAspectRatio="none"
							transform="translate(6884.584746152974, 4291.364476549757)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="366dd673" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="220.15520605509838" height="17.971853555518237" preserveAspectRatio="none"
							transform="translate(6884.584746152974, 4171.77995886779)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="ab369ea" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="220.15520605509838" height="17.971853555518237" preserveAspectRatio="none"
							transform="translate(6884.584746152974, 4052.7875180808373)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="3211421e" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="220.15520605509838" height="17.971853555518237" preserveAspectRatio="none"
							transform="translate(6884.584746152974, 3933.7950772938893)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="dea786b" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="220.15520605509838" height="17.971853555518237" preserveAspectRatio="none"
							transform="translate(6884.584746152974, 3814.8026365069413)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="a8b14ea" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(6883.12448408616,3828.987795843927) rotate(180,0,0) translate(-6883.12448408616,-3828.987795843927)">
						<g>
							<image width="29.603844750590905" height="29.603844750590905" preserveAspectRatio="none"
								transform="translate(6868.322561710865, 3814.1858734686316)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="7e005b8e" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(7012.826328899691,3927.7460110062066) rotate(90,0,0) translate(-7012.826328899691,-3927.7460110062066)">
						<g>
							<image width="59.207689501178194" height="46.25600742279546" preserveAspectRatio="none"
								transform="translate(6983.2224841491025, 3904.618007294809)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="d80bb0d" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(7012.826328899691,3813.5291022371885) rotate(90,0,0) translate(-7012.826328899691,-3813.5291022371885)">
						<g>
							<image width="59.207689501178194" height="46.25600742279546" preserveAspectRatio="none"
								transform="translate(6983.2224841491025, 3790.401098525791)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="20ff90" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(7012.826328899691,4047.1737310295775) rotate(90,0,0) translate(-7012.826328899691,-4047.1737310295775)">
						<g>
							<image width="59.207689501178194" height="46.25600742279546" preserveAspectRatio="none"
								transform="translate(6983.2224841491025, 4024.04572731818)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="d2e0469" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(7012.826328899691,4168.538955999092) rotate(90,0,0) translate(-7012.826328899691,-4168.538955999092)">
						<g>
							<image width="59.207689501178194" height="46.25600742279546" preserveAspectRatio="none"
								transform="translate(6983.2224841491025, 4145.410952287693)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="32c6c298" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(7012.826328899691,4285.092192300881) rotate(90,0,0) translate(-7012.826328899691,-4285.092192300881)">
						<g>
							<image width="59.207689501178194" height="46.25600742279546" preserveAspectRatio="none"
								transform="translate(6983.2224841491025, 4261.964188589483)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="225ee925" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(6348.81473837756,4254.6081421106865) rotate(180,0,0) translate(-6348.81473837756,-4254.6081421106865)">
						<g>
							<image width="31.856554583030025" height="31.856554583030025" preserveAspectRatio="none"
								transform="translate(6332.8864610860455, 4238.679864819172)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="3c67ee6" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="29.603844750589957" height="29.603844750589957" preserveAspectRatio="none"
							transform="translate(6387.068011247315, 4007.0882663889224)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
					</g>
					<g>
						<text fill="rgb(0,0,0)" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="7.32px" font-style="normal" font-weight="normal" text-decoration="normal"
							x="6401.86993362261" y="4022.4391887642178" text-anchor="start" dominant-baseline="central"
							fill-opacity="1"></text>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="a32e098" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="29.603844750589957" height="29.603844750589957" preserveAspectRatio="none"
							transform="translate(6387.127094781623, 3894.932333077909)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(3).2549e2e2.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="d6cd6d6" name="gif"
					stroke="rgb(0,0,0)" stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10"
					stroke-width="0.61" stroke-dasharray="">
					<path fill="none" stroke="none" />
					<g />
					<g>
						<image width="0" height="0" preserveAspectRatio="none"
							transform="translate(6978.796347387576, 3995.534992122635)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/2.9337beff.gif" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="52a5fdb8" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="160.56533756273268" height="111.02922278274069" preserveAspectRatio="none"
							transform="translate(6112.146461563671, 4013.074248982516)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/一级过滤.dccbcd8d.svg" />
					</g>
					<g>
						<text fill="rgb(0,0,0)" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="7.32px" font-style="normal" font-weight="normal" text-decoration="normal"
							x="6192.429130345038" y="4069.1378603738867" text-anchor="start" dominant-baseline="central"
							fill-opacity="1"></text>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="21500c52" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(6101.7228689699305,4115.013371856173) rotate(180,0,0) translate(-6101.7228689699305,-4115.013371856173)">
						<g>
							<image width="29.603844750589957" height="29.603844750589957" preserveAspectRatio="none"
								transform="translate(6086.920946594635, 4100.211449480878)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="3497619e" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="18.15091459568701" height="172.4336886590266" preserveAspectRatio="none"
							transform="translate(6086.930163168209, 4128.339455500525)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/5.fced5a2e.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="9342938" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="22.32334058641097" height="18.60278382200914" preserveAspectRatio="none"
							transform="translate(6115.682593157746, 4311.774205088133)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/6.93fa8947.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="8d914dd" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="27.60610419539712" height="17.81038980348201" preserveAspectRatio="none"
							transform="translate(6260.14471463402, 4019.1449148874462)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/4.429dde95.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="6d5c5aa3" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="134.89071724237698" height="18.106136542600936" preserveAspectRatio="none"
							transform="translate(6252.236377539248, 3895.204897352937)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 1.05699184.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="c0883ec" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(6313.339922459693,3889.0115641277935) rotate(90,0,0) translate(-6313.339922459693,-3889.0115641277935)">
						<g>
							<image width="59.207689501176475" height="46.25600742279412" preserveAspectRatio="none"
								transform="translate(6283.736077709105, 3865.8835604163964)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/总阀.4667513a.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="c2d366b" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="162.69567737042004" height="179.33500801057664" preserveAspectRatio="none"
							transform="translate(6096.7550065924415, 3781.592406170825)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/蓄水池.4ec4de9e.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="6c96785f" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="49.142382285980595" height="49.142382285980595" preserveAspectRatio="none"
							transform="translate(6361.175898338259, 4169.741660712225)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/下载 (2) 1.d907bf88.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="780ae0f0" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="26.64346027553164" height="26.64346027553164" preserveAspectRatio="none"
							transform="translate(6307.456158315513, 3988.1418057485416)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/下载 (2) 1.d907bf88.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="9e78bc6" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="35.5246137007089" height="35.5246137007089" preserveAspectRatio="none"
							transform="translate(6687.397360299979, 4230.647274772975)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/下载 (2) 1.d907bf88.svg" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="463c78e9" name="line"
					line-name="curve">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
				</g>
				<g transform="translate(-6070.677226610852,-3771.592406170825)" id="1c7b655e" name="line"
					line-name="curve">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
				</g>
			</g>
		</svg>
		<div class=""
			style="width: 50px;position: relative;left: -20px;padding: 40px 0 30px 0;font-size: 12px;display: flex;flex-direction: column;justify-content: space-between;">
			<div v-for="item in fertilizerMassifName" :key="item.id">
				{{ item.massif }}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "app",
		components: {},
		props: {
			fertilizerDeviceListOptFor: {
				type: Object,
				default: () => {},
			}
		},
		data() {
			return {
				show: true,
				fertilizerMassifName: []
			};
		},
		watch: {
			'fertilizerDeviceListOptFor': {
				handler: function(newVal) {
					// 监听到fertilizerDeviceListOptFor变化后的操作
					// 可以在这里调用loadingEvent和newDataList等方法
					console.log('oneAisle---newVal',newVal)
					// console.log('oldVal',oldVal)
					this.fertilizerMassifName = JSON.parse(newVal.fertilizerMassifName);
					this.show = false;
					let that = this;
					setTimeout(function() {
						that.show = true;
						setTimeout(function() {
							that.setSVGViewBox();
							that.getFertilizerDevices();
						}, 10);
					}, 1);
				},
				deep: true // 深度监听对象内部值的变化
			}
			// fertilizerDeviceListOptFor(item) {
			// 	console.log("fertilizerDeviceListOptFor", item)
			// 	this.show = false;
			// 	let that = this;
			// 	setTimeout(function() {
			// 		that.show = true;
			// 		setTimeout(function() {
			// 			that.setSVGViewBox();
			// 			that.getFertilizerDevices();
			// 		}, 10);
			// 	}, 1);

			// }
		},
		async mounted() {
			console.log('====================oneAisle')
			this.fertilizerMassifName = JSON.parse(this.fertilizerDeviceListOptFor.fertilizerMassifName);
			// console.log('====================oneAisle', this.fertilizerMassifName)
			let that = this;
			that.setSVGViewBox();
			that.getFertilizerDevices();
			window.addEventListener('resize', this.setSVGViewBox)
		},
		methods: {
			/* 查水肥实时数据 */
			async getFertilizerDevices() {
				this.$emit('loadingEvent', true);
				let httpData = {
					deviceId: this.fertilizerDeviceListOptFor.fertilizerDeviceNumber,
					queueType: 1,
					queueld: ''
				};
				console.log("getRealTimeDeviceDataReadingsArray-httpData", httpData);
				this.$axios.post("/DeviceMqttPushApi/RealTimeDeviceDataReadingsArray", httpData).then((res) => {
					console.log("getRealTimeDeviceDataReadingsArray-res", res);
					if (res.msg == '操作成功') {
						let newDataList = []
						newDataList = newDataList.concat(res.data.sequence4, res.data.sequence5, res.data
							.sequence6, res.data.sequence7, res.data.sequence8, res.data.sequence9, res
							.data.sequence10, res.data.sequence11);
						this.$emit('sonDataList', newDataList);
						console.log("getRealTimeDeviceDataReadingsArray-res操作成功", newDataList);
						for (let i = 0; i < newDataList.length; i++) {
							if (newDataList[i].pointVue == '0066') {
								console.log('操作成功0066', newDataList[i].result)
								this.getSwitchRecording(newDataList[i].result, 0);
							}

							if (newDataList[i].pointVue == '0067') {
								console.log('操作成功0067', newDataList[i].result)
								this.getSwitchRecording(newDataList[i].result, 1);
							}

							if (newDataList[i].pointVue == '0068') {
								console.log('操作成功0068', newDataList[i].result)
								this.getSwitchRecording(newDataList[i].result, 2);
							}
						}
					}
					// uni.hideLoading();

					if (res.code == 500) {
						this.$axios.post("/DeviceMqttPushApi/clearQueue", {
							deviceId: this.fertilizerDeviceListOptFor.fertilizerDeviceNumber,
						}).then((res) => {
							console.log("clearQueue-清空后重查---", res);
							this.getFertilizerDevices();
						}).catch((error) => {
							console.log("clearQueue-error---", error);
							// uni.hideLoading();
						});
					}

				}).catch((error) => {
					console.log("getRealTimeDeviceDataReadingsArray-error", error);
				});
			},
			async getFertilizerDevicessss() {
				this.$emit('loadingEvent', true);
				console.log("执行查询")
				let that = this;
				let httpData = {
					deviceId: that.fertilizerDeviceListOptFor.fertilizerDeviceNumber,
					mark: 'WT_DS_Y_001'
				}
				let data = await that.$axios.post('/DeviceMqttPushApi/RealTimeDeviceDataReading', httpData).then(
					async (res) => {
						console.log("RealTimeDeviceDataReading-res===", res)
						if (res.data) {
							for (let i = 0; i < res.data.length; i++) {
								if (res.data[i].hothouseDeviceDataType == '0066') {
									let number = that.decimalToBinary(res.data[i].hothouseDeviceDataVal);
									let state = that.padTo15Digits(number);
									that.getSwitchRecording(state, 0);
								} else if (res.data[i].hothouseDeviceDataType == '0067') {
									let number = that.decimalToBinary(res.data[i].hothouseDeviceDataVal);
									let state = that.padTo15Digits(number);
									that.getSwitchRecording(state, 1);
								} else if (res.data[i].hothouseDeviceDataType == '0068') {
									let number = that.decimalToBinary(res.data[i].hothouseDeviceDataVal);
									let state = that.padTo15Digits(number);
									that.getSwitchRecording(state, 2);
								}
							}
						} else {
							// res.msg
							// this.$message.error(res.msg);
						}
					})
				console.log("data", data)

			},
			getSwitchRecording(number, type) {
				// console.log("getSwitchRecording-number", number)
				console.log("getSwitchRecording-type", type)
				let switchVal = number.split('').map(Number);
				console.log("getSwitchRecording-switchVal", switchVal)
				let svg = '';
				let image = '';
				if (type == 0) {
					//3水泵启停给定
					if (switchVal[16 - 9] == 1) {
						let list = [{
							id: '780ae0f0',
							img: 'https://drive.le5lecdn.com/2023/1027/1/1/下载 (2).360789ef.gif'
						}, {
							id: '6d5c5aa3',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/组-49.214ad6d3.gif'
						}, {
							id: 'e818b3',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/4.b47b5dcf.gif'
						}, {
							id: '1cc8a3df',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/1.5f631308.gif'
						}, {
							id: '8d914dd',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/3.89eb0239.gif'
						}, {
							id: '3497619e',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/5.2c073fcd.gif'
						}, {
							id: '9342938',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/3.89eb0239.gif'
						}, {
							id: '489ade8',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/6.f3d883c9.gif'
						}, {
							id: '897122f',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/11.031b9afa.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					//4搅拌泵1启停给定
					if (switchVal[16 - 10] == 1) {
						let list = [{
							id: '6c96785f',
							img: 'https://drive.le5lecdn.com/2023/1123/1/1/下载 (2).37f1c27e.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					//12施肥泵启停给定
					if (switchVal[16 - 14] == 1) {
						let list = [{
							id: '9e78bc6',
							img: 'https://drive.le5lecdn.com/2023/1123/1/1/下载 (2).37f1c27e.gif'
						}, {
							id: '103363e',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/30.cbc08d5b.gif'
						}, {
							id: 'ccf2612',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/7.707b5543.gif'
						}, {
							id: '2626491e',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/30.cbc08d5b.gif'
						}, {
							id: 'd9def48',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/2.efdd61a4.gif'
						}, {
							id: '2f5c5ed',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/10.ed5a8ed5.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					//8吸肥电磁阀1启停给定
					if (switchVal[16 - 15] == 1) {
						let list = [{
								id: '308c7e9b',
								img: 'https://drive.le5lecdn.com/2024/0126/1/1/1.5f631308.gif'
							}, {
								id: '474cbf6a',
								img: 'https://drive.le5lecdn.com/2024/0126/1/1/1.5f631308.gif'
							}, {
								id: '0142ccf',
								img: 'https://drive.le5lecdn.com/2024/0127/1/1/33.3f6c2907.gif'
							}
							// ,{
							// 	id: 'ccf2612',
							// 	img: 'https://drive.le5lecdn.com/2023/1030/1/1/9.db4b1f7e.gif'
							// },{
							// 	id: '103363e',
							// 	img: 'https://drive.le5lecdn.com/2023/1030/1/1/8.a7f9a7c2.gif'
							// }
						]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					//13电磁阀1启停给定
					if (switchVal[16 - 3] == 1) {
						let list = [{
							id: 'd80bb0d',
							img: 'https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg'
						}, {
							id: 'dea786b',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					//14电磁阀2启停给定
					if (switchVal[16 - 4] == 1) {
						let list = [{
							id: '3211421e',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					//15电磁阀3启停给定
					if (switchVal[16 - 5] == 1) {
						let list = [{
							id: 'ab369ea',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					//16电磁阀4启停给定
					if (switchVal[16 - 6] == 1) {
						let list = [{
							id: '366dd673',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					//17电磁阀5启停给定
					if (switchVal[16 - 7] == 1) {
						let list = [{
							id: '7b59e9b',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
				}
				this.$emit('loadingEvent', false);
			},
			decimalToBinary(decimal) {
				return (decimal >>> 0).toString(2);
			},
			padTo15Digits(number) {
				return number.toString().padStart(16, '0');
			},
			setSVGViewBox() {
				var divElement = document.getElementById("div");
				var svgElement = document.getElementById("svg");
				var divWidth = divElement.offsetWidth;
				var divHeight = divElement.offsetHeight;
				// console.log("divWidth", divWidth)
				// console.log("divHeight", divHeight)
				// var magnification = 0;
				var viewBoxWidth = 1150;
				var viewBoxHeight = 565;
				var divAspectRatio = divWidth / divHeight;
				var viewBoxAspectRatio = viewBoxWidth / viewBoxHeight;
				var diff = '';
				if (divAspectRatio > viewBoxAspectRatio) {
					diff = (divWidth - divHeight * viewBoxAspectRatio) / 2;
					// console.log("diff", diff)
					svgElement.setAttribute("viewBox", diff + " 0 " + (viewBoxWidth + diff) + " " + viewBoxHeight);
				} else {
					diff = (divHeight - divWidth / viewBoxAspectRatio) / 2;
					svgElement.setAttribute("viewBox", "0 " + diff + " " + viewBoxWidth + " " + (viewBoxHeight + diff));
				}
			},
		},
	};
</script>

<style scoped>

</style>